<template>

  <div class="">
    
      <TopLoaderPages />
    <header class="bg-white shadow" v-if="headingText">
      <div class=" mx-auto ">
        <h1 class="text-2xl font-bold leading-tight text-gray-900">
          {{ headingText }}
        </h1>
      </div>
    </header>
 

<!-- Your Chat plugin code -->
<div >
</div>
    <!--<main class="h-dvh w-screen bg-blue-50 sm:max-sm md:bg-white md:max-w-7xl lg:max-w-7xl mx-auto p-0 md:p-8 pb-4">
      <slot v-if="!loading" />
      
      <Loader v-else />
      
    </main>-->
    <main class="h-[calc(100dvh)] mx-auto p-2 md:max-w-7xl lg:max-w-7xl ">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <slot v-if="!loading" />
      
      <Loader v-else />
    </main>
  </div>
</template>

<script>
import Loader from "../../components/Loader";
//import TopLoaderPages from "../../components/TopLoaderPages";
export default {
  name: "MainLayout",
  components: { Loader },
  props: {
    headingText: {
      type: String,
    },
    loading: Boolean,
  },
};
</script>
